import { useRef } from 'react';
/**
 * This custom React Hook maintains an updated ref of the provided input value.
 * It creates a ref with the initial input value and then immediately updates
 * the current value of the ref to the incoming value.
 *
 * @see https://sail.stripe.me/apis/react/useUpdatedRef
 */ export default function useUpdatedRef(value) {
    const ref = useRef(value);
    // eslint-disable-next-line react-hooks/refs
    ref.current = value;
    return ref;
}

//# sourceMappingURL=useUpdatedRef.js.map